import { Collapsible, CollapsibleTrigger, CollapsibleContent } from "@/components/ui/collapsible";
import { Button } from "@/components/ui/button";
import { ChevronDown, Wrench } from "lucide-react";
import { useState } from "react";
import { resolveToolIcon } from "../../hooks/useBioTools";

export default function ToolsList({ tools }) {
  const [isOpen, setIsOpen] = useState(false);

  if (!tools || tools.length === 0) return null;

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="w-full">
      <CollapsibleTrigger asChild>
        <Button variant="outline" size="sm" className="mx-auto rounded-full gap-2">
          <Wrench className="w-3.5 h-3.5" />
          <span>Available Bio Tools ({tools.length})</span>
          <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
        </Button>
      </CollapsibleTrigger>

      <CollapsibleContent className="mt-4">
        <div className="flex flex-wrap justify-center gap-2">
          {tools.map((tool, index) => {
            const ToolIcon = typeof tool.icon === "string" ? resolveToolIcon(tool.icon) : tool.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs text-muted-foreground"
              >
                <ToolIcon className="w-3.5 h-3.5 flex-shrink-0" />
                <span>{tool.name}</span>
              </div>
            );
          })}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
